import React from 'react';
import './App.css';
import {Header} from './Header';
import {Main} from './Main';

// this component will be rendered by our <___Router>
export const App = () => (
  <div>
    <Header />
    <Main />
  </div>
)

/*class App extends Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
                <Nav />
          </BrowserRouter>
        
        <p className="App-intro">
        More content coming soon...
        </p>
      </div>
    );
  }
}
class App extends Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
            <Switch>
                <Nav />
              <Route exactly component={Start} pattern="/start" />
              <Route exactly component={Links} pattern="/links" />
              <Route exactly component={Contact} pattern="/contact" />
            </Switch>
          </BrowserRouter>
        
        <p className="App-intro">
        More content coming soon...
        </p>
      </div>
    );
  }
}*/



// WEBPACK FOOTER //
// ./src/App.js